module.exports = __webpack_public_path__ + "media/img/pages/profile/aldi ger 6-3de145520d3edfc19f0ee1e7b59e1a0a.jpg";